import { render, staticRenderFns } from "./host-web-ad.vue?vue&type=template&id=649bbaa9&scoped=true&"
import script from "./host-web-ad.vue?vue&type=script&lang=js&"
export * from "./host-web-ad.vue?vue&type=script&lang=js&"
import style0 from "./host-web-ad.vue?vue&type=style&index=0&id=649bbaa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649bbaa9",
  null
  
)

export default component.exports